<template>
    <div :style="thumbnailContainerStyle" class="thumbnail-container">
        <div :style="thumbnailStyle" class="thumbnail">
        <iframe frameborder="0" scrolling="no" :style="iframeStyle" :srcdoc="html" />
        <div class="thumbnail-after" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'CampaignPreview',
    props: {
        html: String,
        height: { type: Number, default: 500 },
        columns: { type: Number, default: 1 }
    },
    computed: {
        thumbnailContainerStyle() {
            let scale = this.getScale();
            return {
                width: `calc(1000px * ${scale})`,
                height: `calc(${this.height}px * ${scale})`,
                display: 'inline-block',
                overflow: 'hidden',
                position: 'relative'
            }
        },
        thumbnailStyle() {
            // https://medium.com/@jamesfuthey/simulating-the-creation-of-website-thumbnail-screenshots-using-iframes-7145269891db
            let scale = this.getScale();
            return {
                'position': 'relative',
                '-ms-zoom': `${scale}`,
                '-moz-transform': `scale(${scale})`,
                '-moz-transform-origin': '0 0',
                '-o-transform': `scale(${scale})`,
                '-o-transform-origin': '0 0',
                '-webkit-transform': `scale(${scale})`,
                '-webkit-transform-origin': '0 0'
            }
        },
        iframeStyle() {
            return {
                border:0,
                width:'1000px',
                height: `${this.height}px`, 
            }
        },
        ...mapState('ui', ['drawer'])
    },
    methods: {
         getScale() {
            /*
            if(!this.existingDesigns) {
                return null;
            }
            let thumbnails = document.querySelectorAll('div');
            if(!thumbnails.length) {
                console.debug('no thumbnail found');
                return null;
            }
            //console.dir(thumbnails);
            console.debug(thumbnails[0].offsetWidth);
            */
           /*
            let columns;
            switch(this.$vuetify.breakpoint.name) {
                case 'xl': columns = 6; break;
                case 'lg': columns = 4; break;
                case 'md': columns = 3; break;
                case 'sm': columns = 2; break;
                case 'xs': columns = 1; break;
            }
            */
            // cols="12" sm="6" md="4" lg="3" xl="2"
            let columns = this.columns;

            console.debug('scale computation bwidth, drawer, columns', this.$vuetify.breakpoint.width, this.drawer, columns);
            let cardWidth = (this.$vuetify.breakpoint.width - (this.drawer ? 272 : 0) - (columns * (48 + (12 / columns)))) / columns;
            let scale = (cardWidth / 1000);//* 100;
            console.debug('card width', cardWidth);
            console.debug('scale', scale);
            // maximum scale is 100%
            return Math.min(scale, 1).toFixed(4);
            //return Math.min(scale, 100);
            //return `${scale}`.replace('.','');
        },
        
    }
}
</script>
<style>
.thumbnail-after {
  display: block;
  position: absolute;
  width: 1000px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>